import React from 'react'
import exact from 'prop-types-exact'
import contributorIcon from 'images/map/dashboards/contributor.svg'

const propTypes = {}

const defaultProps = {}

function ContributorIndicator() {
  return (
    <div className="flex-horizontal open-to-partnerships">
      <div className="contributor-icon">
        <img src={contributorIcon} alt="" aria-hidden />
      </div>
      <p>
        <strong className="contributor-text">
          artlook<sup>®</sup> Contributor
        </strong>
      </p>
    </div>
  )
}

ContributorIndicator.propTypes = exact(propTypes)
ContributorIndicator.defaultProps = defaultProps

export default React.memo(ContributorIndicator)
